import {
  StyledImage,
  StyledImageContainer,
  StyledLoader,
} from './StyledBEImage';
import { forwardRef } from 'react';
import { BEImageProps } from './BEImageProps';
import useImageLoaded from './useImageLoaded';
import { mergeRefs } from '@view/utils/react';

import { ThemeColors } from '@theme/foundations/colors';

const FallBackImage = ({ fallback = 'default' }: BEImageProps) => {
  return (
    <>
      {fallback === 'default' && (
        <svg
          width="70"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          style={{ maxWidth: '40%' }}
        >
          <path
            d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"
            fill={ThemeColors.neutral[400]}
          />
        </svg>
      )}
      {fallback === 'bed' && (
        <svg
          width="70"
          viewBox="0 0 71 62"
          fill="none"
          style={{ maxWidth: '40%' }}
        >
          <path
            d="M11.4375 17.625V22H4.875V4.5C4.875 3.3151 5.28516 2.3125 6.10547 1.49219C7.01693 0.580729 8.0651 0.125 9.25 0.125H61.75C62.9349 0.125 63.9375 0.580729 64.7578 1.49219C65.6693 2.3125 66.125 3.3151 66.125 4.5V22H59.5625V17.625C59.5625 16.4401 59.1068 15.4375 58.1953 14.6172C57.375 13.7057 56.3724 13.25 55.1875 13.25H42.0625C40.8776 13.25 39.8294 13.7057 38.918 14.6172C38.0977 15.4375 37.6875 16.4401 37.6875 17.625V22H33.3125V17.625C33.3125 16.4401 32.8568 15.4375 31.9453 14.6172C31.125 13.7057 30.1224 13.25 28.9375 13.25H15.8125C14.6276 13.25 13.5794 13.7057 12.668 14.6172C11.8477 15.4375 11.4375 16.4401 11.4375 17.625ZM61.75 26.375C64.1198 26.375 66.1706 27.2409 67.9023 28.9727C69.6341 30.7044 70.5 32.7552 70.5 35.125V59.1875C70.5 59.8255 70.2721 60.3268 69.8164 60.6914C69.4518 61.1471 68.9505 61.375 68.3125 61.375H66.125C65.487 61.375 64.9401 61.1471 64.4844 60.6914C64.1198 60.3268 63.9375 59.8255 63.9375 59.1875V52.625H7.0625V59.1875C7.0625 59.8255 6.83464 60.3268 6.37891 60.6914C6.01432 61.1471 5.51302 61.375 4.875 61.375H2.6875C2.04948 61.375 1.5026 61.1471 1.04688 60.6914C0.682292 60.3268 0.5 59.8255 0.5 59.1875V35.125C0.5 32.7552 1.36589 30.7044 3.09766 28.9727C4.82943 27.2409 6.88021 26.375 9.25 26.375H61.75ZM63.9375 46.0625V35.125C63.9375 34.487 63.7096 33.9857 63.2539 33.6211C62.8893 33.1654 62.388 32.9375 61.75 32.9375H9.25C8.61198 32.9375 8.0651 33.1654 7.60938 33.6211C7.24479 33.9857 7.0625 34.487 7.0625 35.125V46.0625H63.9375Z"
            fill={ThemeColors.neutral[400]}
          />
        </svg>
      )}
      {fallback === 'shopping-basket' && (
        <svg
          width="70"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
          style={{ maxWidth: '40%' }}
        >
          <path
            d="M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
            fill={ThemeColors.neutral[400]}
          />
        </svg>
      )}
    </>
  );
};

/* eslint-disable react/display-name */
const BEImage = forwardRef<HTMLImageElement, BEImageProps>(
  ({ src, fallback = 'default', ...rest }, ref) => {
    const { ref: imgRef, loaded, error, onError, onLoad } = useImageLoaded();

    return (
      <StyledImageContainer {...rest}>
        {src && !error && !loaded && <StyledLoader />}
        {src && !error && (
          <StyledImage
            {...rest}
            src={src}
            ref={mergeRefs(ref, imgRef)}
            loading="lazy"
            onError={onError}
            onLoad={onLoad}
          />
        )}
        {(error || !src) && <FallBackImage fallback={fallback} />}
      </StyledImageContainer>
    );
  }
);

export default BEImage;
